export default "<button class=\"Button\">\n  <span class=\"Button-inner\">\n    Example\n  </span>\n  <!-- badge, etc. -->\n</button>\n";